import VArchModel from "./VArchModel";
import { useGLTF } from "@react-three/drei";

export default function VArchSection() {
  return (
    <>
      <VArchModel
        focusYaw={Math.PI / 4}
        projectName="Fine Arts Gallery"
        modelPath="./models/ova/arts_gallery.glb"
        link="https://github.com/OVA-Design/OVA_DCL-Fine-Arts"
        position={[5, 0, -5]}
        scale={0.1}
        rotation={[0, Math.PI / 2, 0]}
      />
      <VArchModel
        focusYaw={Math.PI / 4}
        projectName="Convergence"
        modelPath="./models/ova/convergence.glb"
        link="https://github.com/OVA-Design/OVA_DCL-Convergence"
        position={[15, 0, -5]}
        scale={0.1}
        rotation={[0, Math.PI / 2, 0]}
      />
      <VArchModel
        focusYaw={Math.PI / 4}
        projectName="Virtual Vibes"
        modelPath="./models/ova/virtual_vibes.glb"
        link="https://github.com/OVA-Design/Creativity_Growth_Grant_Decentraland/tree/main/Round%20%232%20-%20Celestial%20Symphony/OVA%20Design/OVA_DCL-Virtual-Vibes"
        position={[5, 0, -15]}
        scale={0.1}
        rotation={[0, Math.PI / 2, 0]}
      />
      <VArchModel
        focusYaw={Math.PI / 4}
        projectName="DCL DAO HQ Town Hall"
        modelPath="./models/ova/dao_hq.glb"
        link="https://github.com/OVA-Design/OVA_DCL-DAO-Headquarters_Town-Hall_Scene_SDK7"
        position={[15, 0, -15]}
        scale={0.1}
        // rotation={[0, Math.PI / 2, 0]}
      />
    </>
  );
}
